import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'

import { newKey } from '../../../tools/mockData'
import { GenericKeyResponseDto } from '../../api/kmsapiclient'
import { updateSigningKeyAsync } from '../../api/signingKeyApi'
import { KeyInfo } from '../../components/common/types'
import { UPDATE_KEYS_PERMISSION } from '../../redux/actions/actionTypes'
import {
  apiCallError,
  beginApiCall,
  endApiCall,
} from '../../redux/actions/apiStatusActions'
import { updateSigningKeySuccess } from '../../redux/actions/signingKeysActions'
import { store, useAppDispatch } from '../../redux/configureStore'
import { SigningKeys } from '../../redux/reducers/initialState'
import KeyForm from '../common/KeyForm'
import { usePermissions } from '../common/permission/usePermissions'
import { getKeyBySlug } from '../common/utils'

type EditSigningKeyPageProps = {
  match: any
  history: any
}

const EditSigningKeyPage = ({ match, history }: EditSigningKeyPageProps) => {
  const signingKeys = useSelector((state: SigningKeys) =>
    state.signingKeys != null && state.signingKeys.keys.length != 0
      ? state.signingKeys.keys
      : [],
  )

  if (signingKeys.length == 0) {
    history.push('/')
  }

  const { checkPermissions } = usePermissions()
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const [entity, setEntity] = useState<KeyInfo>(
    match.params.slug && signingKeys.length !== 0
      ? (getKeyBySlug(signingKeys, match.params.slug) as KeyInfo)
      : newKey,
  )
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    const updatingKey = async () => {
      try {
        await updateSigningKey(entity)
        history.push('/signingkeys')
      } catch (error) {
        setSaving(false)
      }
    }
    if (saving) {
      updatingKey()
    }
  }, [saving])

  const handleChange = (event) => {
    const key = event.target && event.target.name
    const value = event.target && event.target.value
    if (!entity) return
    setEntity({ ...entity, [key]: value })
  }

  const handleOk = () => {
    setSaving(true)
  }

  const handleExited = () => {
    history.push('/signingkeys')
  }

  const updateSigningKey = async (signingKey: KeyInfo) => {
    checkPermissions(store.getState(), UPDATE_KEYS_PERMISSION)

    dispatch(beginApiCall())
    try {
      const updatedSigningKey: GenericKeyResponseDto =
        await updateSigningKeyAsync(signingKey.keyId, signingKey)
      if (updatedSigningKey != null) {
        dispatch(updateSigningKeySuccess(updatedSigningKey))
        toast.success(t('key.key_saved'))
      } else {
        dispatch(endApiCall())
        toast.error(t('key.key_save_failed'))
      }
    } catch (error) {
      dispatch(apiCallError())
      throw error
    }
  }

  return (
    <KeyForm
      keyInfo={entity}
      onChange={handleChange}
      onSave={handleOk}
      onGoBack={handleExited}
    />
  )
}

export default EditSigningKeyPage
